import React from 'react';
import { Hidden } from '@material-ui/core';
import getImplementation from './getResponsiveHidingImplementation';

export default ({ children }: { children: JSX.Element }) => (
  <Hidden smDown implementation={getImplementation()}>
    {children}
  </Hidden>
);
